<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <template>
        <el-col :span="24">
          <h2 style="margin-top: 0;">打卡详情</h2>
        </el-col>
      </template>
      <el-row>
        <el-table
            v-loading="clockInfoLoading"
            :data="clockInfoList"
            border
            size="mini"
            :stripe="true"
            style="width: 100%; margin: 20px 0"
        >
          <el-table-column
              prop="title"
              label="参与打卡活动"
              align="center"
              min-width="13%"
          ></el-table-column>

          <el-table-column
              prop="paid_at"
              label="加入时间"
              align="center"
              min-width="13%"
          ></el-table-column>

          <el-table-column
              prop="diary_num"
              label="发表日记数"
              align="center"
              min-width="13%"
          ></el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-table
            v-loading="clockContentLoading"
            :data="clockContentList"
            border
            size="mini"
            :stripe="true"
            style="width: 100%; margin: 20px 0"
        >
          <el-table-column
              prop="content"
              label="打卡内容"
              align="center"
              min-width="30%"
          ></el-table-column>

          <el-table-column label="图片" align="center" min-width="20%">
            <template slot-scope="{ row }">
              <div v-if="row.image != null">
                <el-button
                    type="success"
                    plain
                    @click="previewImg(row.image)"
                    ref="btn"
                    size="mini"
                >
                  预 览 + {{row.image.length}}
                </el-button>
              </div>
              <div v-else>暂无图片</div>
            </template>
          </el-table-column>

          <el-table-column label="音频" align="center" min-width="20%">
            <template slot-scope="{ row }">
              <div v-if="row.audio != null">
                <el-button
                    type="success"
                    plain
                    @click="previewAudio(row.audio)"
                    ref="btn"
                    size="mini"
                >
                  查 看 + {{row.audio.length}}
                </el-button>
              </div>
              <div v-else>暂无音频</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="record_time"
              label="打卡时间"
              align="center"
              min-width="15%"
          ></el-table-column>

          <el-table-column label="操作" align="center" min-width="15%">
            <template slot-scope="{ row }">
              <el-button
                  type="danger"
                  size="mini"
                  @click="deleteClock(row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <div class="block">
          <el-pagination
              background
              @current-change="contentList"
              :current-page.sync="query.page"
              :page-size="query.limit"
              layout="total, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
        <!-- 图片轮播 -->
        <el-dialog
            title="图片轮播"
            center
            :visible.sync="dialogImgs"
            width="60%"
            @close="closeDialogImgs"
        >
          <el-carousel :autoplay="false" style="height: 500px;">
            <el-carousel-item v-for="(item,index) in imgUrls" :src="item"  :key="index" style="height: 500px;">
              <div style="text-align: center;width: 100%;height: 100%;">
                <img :src="item" class="image-item" style="max-width: 100%;max-height: 100%;"/>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-dialog>

        <!-- 音频播放 -->
        <el-dialog
            title="音频轮播"
            :visible.sync="dialogAudio"
            width="30%"
            @close="closeDialogAudio"
        >
          <template v-for="(item,index) in AudioMp3">
            <div style="text-align: center;width: 100%;height: 100%;">
              <audio :src="item.path" controls="controls"></audio>
            </div>
          </template>
        </el-dialog>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import {
  stuClockInfoList,
  stuClockContentList,
  stuClockDelete
} from "@/api/clockIn";

export default {
  data: function () {
    return {
      dialogVisible: false,
      clockInfoList: [],
      clockInfoLoading: false,
      total: 0,
      query: {
        page: 1,
        limit: 10,
        user_id: this.$route.query.user_id,
        attendance_id: this.$route.query.attendance_id
      },

      clockContentList:[],
      clockContentLoading: false,

      // 图片轮播
      dialogImgs: false,
      imgUrls: [],


      // 音频轮播
      dialogAudio: false,
      AudioMp3: [],
    };
  },
  created: function () {
    this.infoList();
    this.contentList();
  },
  methods: {
    infoList() {
      this.clockInfoLoading = true;
      stuClockInfoList(this.query).then((response) => {
        this.clockInfoList = response.data.list;
        this.clockInfoLoading = false;
      });
    },
    contentList() {
      this.clockContentLoading = true;
      stuClockContentList(this.query).then((response) => {
        this.clockContentList = response.data.list;
        this.total = response.data.total;
        this.clockContentLoading = false;
      });
    },

    deleteClock(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        stuClockDelete({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.contentList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    // 图片
    previewImg(imgs) {
      console.log(imgs);
      this.imgUrls = imgs;
      this.dialogImgs = true;
    },
    closeDialogImgs() {
      this.imgUrls = [];
    },

    // 图片
    previewAudio(audio) {
      console.log(audio);
      this.AudioMp3 = audio;
      this.dialogAudio = true;
    },
    closeDialogAudio() {
      this.AudioMp3 = [];
    },
  },
  mounted() {},
};
</script>